import SubsidiaryFilter from "../../../../../assets/SharedComponents/Filters/SubsidiaryFilter";
import UserFilter from "../../../../../assets/SharedComponents/Filters/UserFilter";

const FilterDrawer = ({
  handleChange,
  filters,
  isFilterApplied,
  _isFilterApplied,
}) => {
  const maxDate = new Date(new Date().setFullYear(new Date().getFullYear()))
    .toISOString()
    .slice(0, 10);

  return (
    <div className="rightSideFilters position-relative mt-4 mb-5">
      <span className="filterHeader mb-5">FILTER</span>
      <div className="filtersInput mt-4">
        <label htmlFor="nomadname" className="form-label">
          <b>User Name</b>
        </label>
        <UserFilter
          _filters={_isFilterApplied}
          filters={isFilterApplied}
          setUser={(val) => handleChange("userId", val)}
          user={filters.userId}
        />
      </div>
      <div className="filtersInput mt-4">
        <label htmlFor="nomadname" className="form-label">
          <b>Subsidiary Name</b>
        </label>
        <SubsidiaryFilter
          _filters={_isFilterApplied}
          filters={isFilterApplied}
          setSub={(val) => handleChange("subId", val)}
          sub={filters.subId}
        />
      </div>
      <div className="filtersInput mt-4">
        <label htmlFor="nomadname" className="form-label">
          <b>Refund requested on</b>
        </label>
        <div className="dateFilter">
          {["refundRequestedOnFrom", "refundRequestedOnTo"].map((dateKey) => (
            <input
              key={dateKey}
              type={filters[dateKey] ? "date" : "text"}
              className="filterBox date"
              placeholder={dateKey === "refundRequestedOnFrom" ? "From" : "To"}
              max={
                dateKey === "refundRequestedOnFrom"
                  ? filters.endDate || maxDate
                  : maxDate
              }
              value={filters[dateKey]}
              onFocus={(e) => (e.target.type = "date")}
              onBlur={(e) => {
                if (!filters[dateKey]) e.target.type = "text";
              }}
              onChange={(e) => handleChange(dateKey, e.target.value)}
            />
          ))}
        </div>
      </div>
      <div className="filtersInput mt-4">
        <label htmlFor="nomadname" className="form-label">
          <b>Refund approved on</b>
        </label>
        <div className="dateFilter">
          {["refundApprovedOnFrom", "refundApprovedOnTo"].map((dateKey) => (
            <input
              key={dateKey}
              type={filters[dateKey] ? "date" : "text"}
              className="filterBox date"
              placeholder={dateKey === "refundApprovedOnFrom" ? "From" : "To"}
              max={
                dateKey === "refundApprovedOnFrom"
                  ? filters.endDate || maxDate
                  : maxDate
              }
              value={filters[dateKey]}
              onFocus={(e) => (e.target.type = "date")}
              onBlur={(e) => {
                if (!filters[dateKey]) e.target.type = "text";
              }}
              onChange={(e) => handleChange(dateKey, e.target.value)}
            />
          ))}
        </div>
      </div>
      <div className="filtersInput mt-4">
        <label htmlFor="nomadname" className="form-label">
          <b>Refund sent on</b>
        </label>
        <div className="dateFilter">
          {["refundSentOnFrom", "refundSentOnTo"].map((dateKey) => (
            <input
              key={dateKey}
              type={filters[dateKey] ? "date" : "text"}
              className="filterBox date"
              placeholder={dateKey === "refundSentOnFrom" ? "From" : "To"}
              max={
                dateKey === "refundSentOnFrom"
                  ? filters.endDate || maxDate
                  : maxDate
              }
              value={filters[dateKey]}
              onFocus={(e) => (e.target.type = "date")}
              onBlur={(e) => {
                if (!filters[dateKey]) e.target.type = "text";
              }}
              onChange={(e) => handleChange(dateKey, e.target.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterDrawer;
